

import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Table } from 'primeng/table';
import { ApiService } from 'src/app/_services/api.service';
import { GlobalService } from 'src/app/_services/global.service';
import * as uuid from 'uuid';
import { registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it';
import localeDeExtra from '@angular/common/locales/extra/de';

registerLocaleData(localeIt, 'it-IT', localeDeExtra);

@Component({
  selector: 'app-tipimonitors',
  templateUrl: './tipimonitors.component.html',
  styleUrls: ['./tipimonitors.component.css'],
  providers: [MessageService, ConfirmationService]
})
export class TipimonitorsComponent implements OnInit {
    @ViewChild('maintable') maintable:any;
    

      
    dataList:any[]=[];
    clonedSez:any[]=[];
    cols:any[]=[];
    loading:boolean = true;

  constructor(
    private apiService: ApiService,
    public globalService : GlobalService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService, 
    public router: Router,
  ) { }

    ngOnInit(): void {  

      this.apiService.post('kodi/tipimonitor_listall',{}).subscribe(data2 => {
        this.dataList=data2.Result;
        this.loading = false;
      });
     
          
      
    }

    nuovoRecord() {
      let newS:any = {'tipomonitor':''};
      newS['id']=uuid.v4()
      this.dataList.unshift(newS);
      this.maintable.editingRowKeys[newS[this.maintable.dataKey]] = true;
      this.onRowEditInit(newS);
     
      
    }
  
    
  
    onRowEditInit(sez: any) {
      this.clonedSez[sez.id] = { ...sez };
    }
    
    onEditComplete(event:any){
     
    }

    onRowEditSave(record: any) {
      
      
 
    }
  
    onRowEditCancel(camera: any, index: number) {
      this.dataList[index] = this.clonedSez[camera.id];
      delete this.dataList[camera.id];
    }
  
    deleteRecord(record: any){
      this.dataList = this.dataList.filter((item:any) => item.id !== record.id);
    
    }
    
    addSingle(sev: string, sum: string, det: string) {
      this.messageService.add({severity: sev, summary: sum, detail: det});
    }

    salva(){
      let param={
        tipimonitors:this.dataList
      }
      this.apiService.post('kodi/tipimonitor_update',param).subscribe(data => {
        this.addSingle('success', 'Successo', 'Elenco salvato');
      
      

    });

    }
    
    
    
  }
